import { getMemberProfiles } from "../../api/MemberProfileApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { TeamMemberPriceImputValidation } from "../common/GeneralConfigurations";

export const MemberProfileValidation = (form) => [
    {
        validator: async (_, memberProfile) => {
            if (memberProfile) {
                let base64ProfileDescription = Buffer.from(memberProfile).toString('base64');
                await getMemberProfiles(base64ProfileDescription, form.getFieldValue("experience"), true).then(res => {
                    if (res.status == 200) {
                        if (res.data.result.length === 0) {
                            return Promise.reject(
                                "Member Profile is invalid"
                            );
                        }
                    } else {
                        AdnMessageError("Couldn't validate");
                    }
                })
            }
        }
    },
    { required: true, message: 'Publish Date is required' },
];

export const ExperienceValidation = [
    { required: true, message: "Input something" },
];

export const PriceValidation = [
    { required: true },
    { pattern: TeamMemberPriceImputValidation, message: "Price is not Valid" },
]

export const AllocationHoursValidation = [
    { required: true, message: "Allocation Hours are required" },
]

export const AllocationPercentageValidation = [
    { required: true, message: "Allocation Percentage is required" },
]